import Vue from 'vue'
import { API_URL } from '@/config'
import router from '@/router'
import { getValues, prepareValues } from '@/lib/values'
import { setTime } from '@/lib/times'

export const session_edit = {

  namespaced: true,

  state: {
    values: {},
    entities: [],
  },

  getters: {
    values: state => state.values,
    entities: state => state.entities,
  },

  mutations: {
    setValues(state, values) { state.values = values },
    setEntities(state, entities) { state.entities = entities },
    setDays(state, days) { 
      let ekey = state.entities.findIndex((entity) => entity.column === 'day_id');
      if (ekey >= 0) {
        state.entities[ekey].format = 'date';
        state.entities[ekey].options = days.reduce((carry, day) => {
          carry.push({ value: day.id, name: day.date });
          return carry;
        }, []);
      }
    },
    setRooms(state, params) {
      let ekey = state.entities.findIndex((entity) => entity.column === 'room_id');
      if (ekey >= 0) {
        state.entities[ekey].options = params.rooms.reduce((carry, room) => {
          carry.push({ value: room.id, name: room['name_' + params.language] });
          return carry;
        }, []);
      }
      ekey = state.entities.findIndex((entity) => entity.column === 'virtual_room_id');
      if (ekey >= 0) {
        state.entities[ekey].options = params.rooms.reduce((carry, room) => {
          carry.push({ value: room.id, name: room['name_' + params.language] });
          return carry;
        }, []);
      }
    },
  },

  actions: {

    getEntities: () => Vue.axios.get(API_URL + '/entities', { params: {
      models: ['App\\Models\\Session'],
      form_display: true,
    }}),

    getDays: () => Vue.axios.get(API_URL + '/days', { params: {
      sorts: [
        { 'column': 'days.order', 'order': 'asc'}
      ],
    }}),

    getRooms: () => Vue.axios.get(API_URL + '/rooms', { params: {
      sorts: [
        { 'column': 'rooms.order', 'order': 'asc'}
      ],
    }}),

    async getForm({ rootState, rootGetters, commit, dispatch }) {
      commit('clearResponse', {}, { root: true });
      commit('setEntities', []);
      const [entities, days, rooms] = await Promise.all([
        dispatch('getEntities'),
        dispatch('getDays'),
        dispatch('getRooms'),
      ]);
      commit('setProgress', false, { root: true });
      let values = getValues('session', entities.data['App\\Models\\Session'], 'content');
      let add = rootGetters['schedule/add'];
      if (add.day_id !== null) {
        values.day_id = add.day_id;
        values.room_id = add.room_id;
        values.start_time = add.start_time;
        values.end_time = add.end_time;
        commit('schedule/setAdd', {
          day_id: null,
          room_id: null, 
          start_time: '',
          end_time: '',
        }, { root: true });
      }
      commit('setValues', values);
      commit('setEntities', entities.data['App\\Models\\Session']);
      commit('setDays', days.data.items);
      rooms.data.items = rooms.data.items.map(room => {
        room['name_' + rootGetters.language] = room['name_' + rootGetters.language];
        return room;
      })
      commit('setRooms', { rooms: rooms.data.items, language: rootState.language });
    },

    async validateSession({ state, rootState, commit, dispatch }) {
      if (!rootState.progress) {
        state.values.start_time = setTime(state.values.start_time);
        state.values.end_time = setTime(state.values.end_time);
        try {
          await Vue.axios.post(API_URL + '/validate?model=App\\Models\\Session', state.values, {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          });
        } catch (error) {
          commit('setProgress', false, { root: true });
          commit('setResponse', { status: true, type: 'error', message: 'form_error', errors: error.response.data.errors }, { root: true });
          return;
        }
        let values = prepareValues(state.values, 'content_');
        dispatch(((!router.currentRoute.params.id) ? 'create' : 'update') + 'Session', values);
      }
    },

    async createSession({ commit }, values) {
      const session = await Vue.axios.post(API_URL + '/sessions', values);
      commit('session/setSession', session.data, { root: true });
      commit('setProgress', false, { root: true });
      router.push('/session/' + session.data.id + '/edit');
      commit('setResponse', { status: true, type: 'success', message: 'session_successfully_created' }, { root: true });
    },

    async updateSession({ state, commit }, values) {
      const session = await Vue.axios.put(API_URL + '/sessions/' + router.currentRoute.params.id, values);
      commit('session/setSession', session.data, { root: true });
      commit('setValues', getValues('session', state.entities, 'content'));
      commit('setProgress', false, { root: true });
      commit('setResponse', { status: true, type: 'success', message: 'session_successfully_updated' }, { root: true });
    },

  }
}
